export default {
  nav: {
    technology: "ODF-technologie",
    solutions: "Oplossingen",
    partnerships: "Partnerschappen",
    about: "Over ons",
    contact: "Neem contact op",
    home: "Home",
  },
  hero: {
    eyebrow: "ODF-OPLOSSINGEN VAN DE NIEUWE GENERATIE",
    headline1: "Innovatie,",
    headline2: "geleverd in elke film.",
    copy: "NORTIS brengt geavanceerde smelttabletfilms (Orally Dissolving Films, ODF) naar moderne wellnessmerken en internationale markten — en combineert een praktisch formaat met betrouwbare commerciële expertise.",
    cta1: "Ontdek de ODF-technologie",
    cta2: "Word partner van NORTIS",
    trust: "Ontworpen voor moderne levensstijlen. Gebouwd voor wereldwijde kansen.",
    scroll: "Scrollen",
  },
  brandline: "Geavanceerde toediening. Moeiteloze ervaring.",
  credibility: {
    title: "Een slimmer formaat voor een veranderende wereld.",
    copy: "In de mond oplosbare films bieden een verfijnde en praktische manier om zorgvuldig samengestelde ingrediënten toe te dienen — zonder de conventionele ervaring van tabletten, capsules of vloeistoffen.",
  },
  whatIsOdf: {
    eyebrow: "HET FORMAAT",
    title: "Wat is ODF?",
    copy: "Een ODF is een ultradunne orale film die comfortabel in de mond oplost. Het compacte formaat biedt een modern alternatief voor merken die draagbare, gebruiksvriendelijke wellnesservaringen ontwikkelen.",
    benefits: [
      { title: "Dun en draagbaar", desc: "Een ultradun formaat dat moeiteloos meereist — in een zak, portemonnee of tas." },
      { title: "Gebruik zonder water", desc: "Ontworpen om overal en altijd te gebruiken, zonder water of voorbereiding." },
      { title: "Precieze presentatie", desc: "Elke film is een individueel gepresenteerde eenheid, verpakt voor consistentie." },
      { title: "Gemaakt voor innovatie", desc: "Een flexibele basis voor moderne productconcepten en onderscheidende merkervaringen." },
    ],
  },
  whyNortis: {
    eyebrow: "WAAROM NORTIS",
    title: "Meer dan een productformaat. Een complete marktkans.",
    copy: "NORTIS is de brug tussen ODF-innovatie en commerciële markten — en verbindt veelbelovende producten met partners die ze kunnen opschalen.",
    points: [
      { title: "Commerciële expertise gericht op ODF", desc: "Een toegewijde focus op de categorie van in de mond oplosbare films en haar commerciële dynamiek." },
      { title: "Internationale sourcing en marktontwikkeling", desc: "Kansen identificeren en routes naar de markt opbouwen in verschillende regio's." },
      { title: "Ondersteuning bij product- en merkpositionering", desc: "Wij helpen partners hun ODF-concepten af te stemmen op hun doelgroepen en kanalen." },
      { title: "Flexibele B2B-partnermodellen", desc: "Distributie, private label en marktontwikkeling — gestructureerd rond uw doelstellingen." },
      { title: "Kwaliteitsbewuste selectie", desc: "Gedisciplineerde beoordeling van geschiktheid, documentatie en marktgereedheid." },
      { title: "Langdurige relaties", desc: "Partnerschappen gebouwd voor duurzame, cumulatieve commerciële groei." },
    ],
  },
  solutions: {
    eyebrow: "OPLOSSINGENPORTFOLIO",
    title: "Een portfolio ontworpen rond het moderne leven.",
    copy: "Ontdek de oplossingscategorieën die NORTIS samen met partners en markten wereldwijd ontwikkelt.",
    viewAll: "Bekijk alle oplossingen",
    requestInfo: "Productinformatie aanvragen",
    possibilitiesLabel: "Ontwikkelingsmogelijkheden",
    positioningLabel: "Commerciële positionering",
    availabilityLabel: "Marktbeschikbaarheid",
    targetLabel: "Doelmarkt",
    docLabel: "Documentatiestatus",
    sheetLabel: "Informatieblad",
    sheetOnRequest: "Op aanvraag beschikbaar",
    demoBadge: "Demonstratieconcept",
    filterAll: "Alle",
    pageTitle: "Oplossingen",
    pageSub: "Een filterbaar portfolio van ODF-oplossingscategorieën — zo gestructureerd dat echte producten kunnen worden toegevoegd naarmate partnerschappen zich ontwikkelen.",
    demoNote: "De onderstaande items zijn demonstratieconcepten die de richting van elke categorie illustreren. Werkelijke commerciële producten worden geïntroduceerd binnen actieve partnerschappen.",
  },
  comparison: {
    eyebrow: "FORMAATERVARING",
    title: "Hoe het filmformaat zich verhoudt.",
    copy: "Een neutrale blik op de praktische eigenschappen van alledaagse formaten.",
    note: "Uitsluitend een neutrale vergelijking van praktische formaateigenschappen. Geen uitspraak over klinische prestaties of werkzaamheid.",
    formats: ["ODF-film", "Tabletten", "Capsules", "Vloeistoffen"],
    rows: [
      { label: "Draagbaarheid", values: [2, 2, 2, 0] },
      { label: "Gebruik zonder water", values: [2, 0, 0, 1] },
      { label: "Individueel voorgedoseerd formaat", values: [2, 2, 2, 0] },
      { label: "Gemakkelijke opslag", values: [2, 2, 1, 0] },
      { label: "Discreet gebruik onderweg", values: [2, 1, 1, 0] },
    ],
  },
  models: {
    eyebrow: "PARTNERMODELLEN",
    title: "Drie manieren om met NORTIS te bouwen.",
    cta: "Bespreek een partnerschap",
    items: [
      { title: "Distributie", desc: "Breng geselecteerde ODF-producten naar nieuwe regio's en commerciële netwerken." },
      { title: "Private label", desc: "Ontwikkel onderscheidende ODF-concepten onder uw eigen merk." },
      { title: "Marktontwikkeling", desc: "Bouw samen met NORTIS aan productpositionering, lanceringsstrategie en een duurzame marktpositie." },
    ],
  },
  timeline: {
    eyebrow: "HOE DE SAMENWERKING VERLOOPT",
    title: "Van het eerste gesprek tot groei in de markt.",
    steps: [
      { title: "Kansen verkennen", desc: "We verkennen uw doelstellingen, uw markten en de ODF-concepten die daarbij passen." },
      { title: "Product- en marktafstemming", desc: "De juiste producten koppelen aan de juiste commerciële context." },
      { title: "Commerciële beoordeling", desc: "Voorwaarden, volumes en een realistisch commercieel kader structureren." },
      { title: "Compliance en lanceringsvoorbereiding", desc: "Documentatie en marktvereisten beoordelen vóór de lancering." },
      { title: "Distributie en groei", desc: "Ondersteuning bij uitrol, uitbreiding en langdurige groei van het partnerschap." },
    ],
  },
  quality: {
    eyebrow: "KWALITEIT EN VERANTWOORDELIJKHEID",
    title: "Kwaliteit begint met de juiste vragen.",
    copy: "NORTIS beoordeelt bij elk potentieel partnerschap de geschiktheid van het product, de documentatie, de commerciële gereedheid en de marktvereisten. De beschikbaarheid en de wettelijke status van producten kunnen per land verschillen.",
    placeholder: "Geverifieerde kwaliteitsdocumentatie en certificeringen worden hier gepubliceerd naarmate partnerschappen vorderen.",
  },
  global: {
    eyebrow: "WERELDWIJDE VISIE",
    title: "Gebouwd voor internationale samenwerking",
    copy: "Wij werken samen met merken, leveranciers, distributeurs en commerciële partners om waardevolle ODF-kansen te identificeren in zich ontwikkelende wereldwijde markten.",
  },
  finalCta: {
    title: "Laten we samen de volgende generatie orale wellness vormgeven.",
    copy: "Of u nu distributie, private label of een nieuw ODF-productconcept verkent — NORTIS staat klaar om het gesprek te beginnen.",
    cta: "Start een gesprek",
  },
  footer: {
    desc: "NORTIS verbindt innovatieve ODF-producten met merken, partners en markten wereldwijd.",
    nav: "Navigatie",
    legal: "Juridisch",
    privacy: "Privacybeleid",
    terms: "Gebruiksvoorwaarden",
    language: "Taal",
    disclaimer: "De beschikbaarheid, samenstelling, classificatie en wettelijke status van producten kunnen per land verschillen. De informatie op deze website is bedoeld voor commerciële en algemene informatiedoeleinden en vormt geen medisch advies.",
    rights: "Alle rechten voorbehouden.",
  },
  tech: {
    eyebrow: "ODF-TECHNOLOGIE",
    title: "De wetenschap van het dunne.",
    sub: "Een informatief overzicht van de in de mond oplosbare film — het formaat, de ervaring en de commerciële mogelijkheden die het opent.",
    what: {
      title: "Wat is een in de mond oplosbare film?",
      copy: "Een in de mond oplosbare film (ODF) is een ultradun laagje dat comfortabel in de mond oplost. In plaats van een tablet door te slikken of een vloeistof af te meten, plaatst de gebruiker eenvoudig één film en laat deze oplossen — een onopvallende, moderne ervaring in een opmerkelijk compact formaat.",
    },
    structure: {
      title: "De algemene opbouw van de film",
      copy: "Conceptueel combineert een ODF een structurele filmbasis, een dragermatrix met de samengestelde ingrediënten en een sensorische laag die smaak en textuur bepaalt. Beweeg de muis over het diagram of tik erop om de conceptuele lagen te scheiden.",
      note: "Conceptuele weergave, uitsluitend ter illustratie.",
      layers: [
        { title: "Sensorische laag", desc: "Bepaalt de smaak, de textuur en de oplos-ervaring." },
        { title: "Dragermatrix", desc: "Bevat de zorgvuldig samengestelde ingrediënten in de film." },
        { title: "Structurele basis", desc: "Geeft de film zijn stevigheid, dunheid en stabiliteit." },
      ],
    },
    experience: {
      title: "De gebruikerservaring",
      copy: "Geen water. Geen afmeten. Geen onderbreking. Een film lost discreet op, waardoor gebruik tijdens het reizen, werken of onderweg vanzelfsprekend is. Voor moderne consumenten wordt het formaat zelf onderdeel van de merkervaring.",
    },
    portability: {
      title: "Draagbaarheid en verpakkingspotentieel",
      copy: "Individuele films kunnen worden gepresenteerd in dunne sachets, elegante multipacks of compacte dispensers — formaten die passen bij zowel moderne winkelschappen als direct-to-consumer unboxing-momenten.",
    },
    development: {
      title: "Mogelijkheden voor productontwikkeling",
      copy: "Het filmformaat ondersteunt een breed scala aan productconcepten — van dagelijkse wellnessroutines tot gerichte lifestylepositionering — en geeft merken ruimte om zich te onderscheiden in verzadigde categorieën.",
    },
    commercial: {
      title: "Commerciële toepassingen",
      copy: "ODF-concepten worden ontwikkeld in de categorieën wellness, beauty-from-within, energie, slaap en functionele ingrediënten — kanalen waar gemak en een premium ervaring de aankoopbeslissingen bepalen.",
    },
    regulatory: {
      title: "Markt- en regelgevingsaspecten",
      copy: "De classificatie en vereisten voor filmproducten verschillen per land en per samenstelling. NORTIS benadert elke markt individueel en beoordeelt de documentatie en het regelgevingskader samen met partners vóór de commercialisering.",
    },
    cta: "Technische informatie aanvragen",
  },
  partnership: {
    eyebrow: "PRIVATE LABEL EN DISTRIBUTIE",
    title: "Twee routes. Eén partnerschapsstandaard.",
    sub: "NORTIS structureert commerciële samenwerkingen rond twee kernmodellen — beide ontworpen voor duidelijkheid, snelheid en langdurige groei.",
    plTitle: "Private label",
    plDesc: "Ontwikkel onderscheidende ODF-concepten onder uw eigen merk, waarbij NORTIS het traject van concept tot schap coördineert.",
    plSteps: ["Conceptbeoordeling", "Productselectie", "Coördinatie van branding en verpakking", "Beoordeling van documentatie", "Voorbereiding van de marktlancering", "Commerciële opschaling"],
    distTitle: "Distributie",
    distDesc: "Breng geselecteerde ODF-producten naar uw regio en commerciële netwerk, met gestructureerde ondersteuning in elke fase.",
    distSteps: ["Regiobeoordeling", "Portfolio-afstemming", "Commerciële voorwaarden", "Planning van markttoetreding", "Lanceringsondersteuning", "Langdurige groei"],
    formTitle: "Start een partnerschapsaanvraag",
    formSub: "Vertel ons over uw doelstellingen en ons team reageert met de volgende stappen.",
  },
  about: {
    eyebrow: "OVER NORTIS",
    title: "Gefocust op het formaat dat de toekomst vormt.",
    copy: "NORTIS is opgericht om veelbelovende ODF-innovaties te verbinden met de merken, partners en markten die ze kunnen omzetten in betekenisvolle commerciële producten. Wij combineren ondernemende snelheid, internationaal denken en een gedisciplineerde benadering van langdurige partnerschappen.",
    positioning: "NORTIS verbindt innovatieve ODF-producten met merken, partners en markten wereldwijd.",
    principlesTitle: "Onze principes",
    principles: [
      { title: "Precisie", desc: "Zorg voor elk detail — van productbeoordeling tot communicatie met partners." },
      { title: "Vertrouwen", desc: "Transparante verwachtingen en toezeggingen die we willen nakomen." },
      { title: "Vooruitgang", desc: "Een duidelijke gerichtheid op ontwikkeling en moderne formaten." },
      { title: "Partnerschap", desc: "Relaties ontworpen om jaren te groeien, niet slechts kwartalen." },
      { title: "Wereldwijd perspectief", desc: "Denken over grenzen, markten en consumentenculturen heen." },
    ],
  },
  contact: {
    eyebrow: "CONTACT",
    title: "Laten we het gesprek beginnen.",
    sub: "Deel enkele details over uw interesse en ons team neemt contact met u op.",
    name: "Volledige naam",
    company: "Bedrijf",
    email: "Zakelijk e-mailadres",
    country: "Land",
    website: "Website",
    interest: "Interesse in partnerschap",
    market: "Beoogde markt of regio",
    message: "Bericht",
    consent: "Ik geef NORTIS toestemming om mijn gegevens op te slaan om deze aanvraag te beantwoorden.",
    submit: "Bericht versturen",
    sending: "Wordt verzonden…",
    successTitle: "Bedankt — uw bericht is ontvangen.",
    successCopy: "Ons team beoordeelt uw aanvraag en neemt binnenkort contact met u op.",
    successAnother: "Nog een bericht versturen",
    errorRequired: "Dit veld is verplicht.",
    errorEmail: "Voer een geldig zakelijk e-mailadres in.",
    errorConsent: "Uw toestemming is vereist om het formulier te versturen.",
    errorSubmit: "Er is iets misgegaan. Probeer het opnieuw.",
    optional: "Optioneel",
    interests: {
      distribution: "Distributie",
      privateLabel: "Private label",
      sourcing: "Productsourcing",
      marketDev: "Marktontwikkeling",
      general: "Algemeen partnerschap",
      product: "Productinformatie",
      technical: "Technische informatie",
    },
    selectPlaceholder: "Selecteer een optie",
  },
  legal: {
    privacyTitle: "Privacybeleid",
    termsTitle: "Gebruiksvoorwaarden",
    updated: "Laatst bijgewerkt",
    privacy: [
      { h: "1. Overzicht", p: "Dit privacybeleid legt uit hoe NORTIS via deze website verstrekte informatie verzamelt, gebruikt en beschermt. Wij verplichten ons om zakelijke contactgegevens verantwoord en transparant te verwerken." },
      { h: "2. Informatie die wij verzamelen", p: "Wanneer u een contact- of partnerschapsformulier verstuurt, verzamelen wij de door u verstrekte gegevens, zoals uw naam, bedrijf, zakelijk e-mailadres, land, website, interessegebied en de inhoud van uw bericht." },
      { h: "3. Hoe wij informatie gebruiken", p: "Verstrekte gegevens worden uitsluitend gebruikt om uw aanvraag te beantwoorden, een mogelijke commerciële samenwerking te beoordelen en met u te communiceren over relevante partnerschapskwesties. Wij verkopen geen persoonsgegevens." },
      { h: "4. Gegevensopslag en beveiliging", p: "Formulierinzendingen worden veilig opgeslagen in de database van onze applicatie. Toegang is beperkt tot medewerkers die deze nodig hebben om aanvragen te beantwoorden. Wij nemen redelijke technische maatregelen om opgeslagen gegevens te beschermen." },
      { h: "5. Bewaartermijn", p: "Wij bewaren aanvraaggegevens zo lang als nodig is voor het beheer van de zakelijke relatie of zoals vereist door de toepasselijke wetgeving. U kunt verwijdering van uw gegevens aanvragen door contact met ons op te nemen." },
      { h: "6. Uw rechten", p: "Afhankelijk van uw jurisdictie heeft u mogelijk het recht om de persoonsgegevens die wij over u bewaren in te zien, te corrigeren of te laten verwijderen. Neem contact met ons op via de website om deze rechten uit te oefenen." },
      { h: "7. Wijzigingen in dit beleid", p: "Wij kunnen dit privacybeleid van tijd tot tijd bijwerken. Belangrijke wijzigingen worden op deze pagina weergegeven met een bijgewerkte revisiedatum." },
    ],
    terms: [
      { h: "1. Aanvaarding van de voorwaarden", p: "Door deze website te bezoeken en te gebruiken, gaat u akkoord met deze gebruiksvoorwaarden. Als u niet akkoord gaat, verzoeken wij u het gebruik van de site te staken." },
      { h: "2. Informatief doel", p: "De inhoud van deze website wordt uitsluitend aangeboden voor commerciële en algemene informatiedoeleinden. Deze vormt geen medisch, juridisch of regelgevend advies, en geen enkele inhoud mag worden opgevat als een productclaim." },
      { h: "3. Productbeschikbaarheid", p: "De beschikbaarheid, samenstelling, classificatie en wettelijke status van producten kunnen per land verschillen. Niets op deze website vormt een aanbod tot verkoop van een product in een specifieke jurisdictie." },
      { h: "4. Intellectueel eigendom", p: "De naam NORTIS, de visuele identiteit en de inhoud van de website zijn eigendom van NORTIS. U mag de inhoud van de site niet reproduceren of verspreiden zonder voorafgaande schriftelijke toestemming." },
      { h: "5. Beperking van aansprakelijkheid", p: "NORTIS doet redelijke inspanningen om de informatie op de website accuraat te houden, maar staat niet in voor de volledigheid ervan. Voor zover wettelijk toegestaan, is NORTIS niet aansprakelijk voor beslissingen die op basis van de website-inhoud worden genomen." },
      { h: "6. Links van derden", p: "Deze website kan links naar bronnen van derden bevatten. NORTIS is niet verantwoordelijk voor de inhoud of praktijken van externe sites." },
      { h: "7. Geldigheid van de voorwaarden", p: "Deze voorwaarden kunnen periodiek worden bijgewerkt. Voortgezet gebruik van de website geldt als aanvaarding van de actuele versie." },
    ],
  },
  seo: {
    home: { title: "NORTIS — Geavanceerde ODF-oplossingen | Partner in oplosbare films", desc: "NORTIS verbindt innovatieve in de mond oplosbare film (ODF)-producten met merken, partners en markten wereldwijd. Distributie, private label en marktontwikkeling." },
    tech: { title: "ODF-technologie — NORTIS", desc: "Een informatief overzicht van de technologie van in de mond oplosbare films: formaat, opbouw, gebruikerservaring en commerciële mogelijkheden." },
    solutions: { title: "ODF-oplossingenportfolio — NORTIS", desc: "Ontdek ODF-oplossingscategorieën: dagelijkse wellness, energie, beauty, slaap, functionele ingrediënten en private-labelconcepten op maat." },
    partnership: { title: "Private label en distributie — NORTIS", desc: "Word partner van NORTIS via distributie-, private-label- of marktontwikkelingsmodellen voor ODF-producten." },
    about: { title: "Over NORTIS — Gefocust op het formaat van morgen", desc: "NORTIS verbindt veelbelovende ODF-innovaties met merken, partners en markten die er commerciële producten van kunnen maken." },
    contact: { title: "Contact met NORTIS — Start een gesprek", desc: "Neem contact op met het NORTIS-team over ODF-distributie, private label, sourcing of marktontwikkeling." },
    privacy: { title: "Privacybeleid — NORTIS", desc: "Hoe NORTIS via deze website verstrekte informatie verzamelt, gebruikt en beschermt." },
    terms: { title: "Gebruiksvoorwaarden — NORTIS", desc: "Voorwaarden voor het gebruik van de NORTIS-website en de informatieve inhoud ervan." },
  },
  a11y: {
    mainNav: "Hoofdnavigatie",
    mobileNav: "Mobiele navigatie",
    homeLink: "NORTIS startpagina",
    openMenu: "Menu openen",
    closeMenu: "Menu sluiten",
    langSelector: "Taal selecteren",
    filmDiagram: "Interactief diagram van de filmlagen",
    linkedinLabel: "NORTIS op LinkedIn",
    techImageAlt: "Abstracte gelaagde filmvellen",
    yes: "Ja",
    partial: "Gedeeltelijk",
    no: "Nee",
    filters: "Oplossingsfilters",
  },
  solutionsData: {
    "daily-wellness": {
      name: "Dagelijkse wellness",
      desc: "Filmconcepten voor elke dag, ontworpen om naadloos aan te sluiten op moderne ochtend- en avondroutines.",
      possibilities: ["Routinegebaseerde productlijnen", "Abonnementsvriendelijke formaten", "Minimalistische premium verpakking"],
      positioning: "Gepositioneerd voor consumenten die moeiteloze dagelijkse consistentie zoeken.",
      availability: "In ontwikkeling met partners",
      targetMarket: "Wellness- en lifestyle-retail",
      docStatus: "Per markt voorbereid",
    },
    "energy-performance": {
      name: "Energie en prestaties",
      desc: "Concepten voor onderweg, voor consumenten die waarde hechten aan momentum — vóór een training, een reis of een veeleisende dag.",
      possibilities: ["Positionering vóór activiteiten", "Compacte multipack-formaten", "Gedurfde, moderne merktaal"],
      positioning: "Gemaakt voor snelle, gemaksgerichte consumptiemomenten.",
      availability: "In ontwikkeling met partners",
      targetMarket: "Active-lifestyle- en sportkanalen",
      docStatus: "Per markt voorbereid",
    },
    "beauty-aging": {
      name: "Beauty en gezond ouder worden",
      desc: "Elegante filmconcepten voor de beauty-from-within-categorie, waar ervaring en esthetiek het verschil maken.",
      possibilities: ["Premium beautypositionering", "Verpakkingsconcepten als cadeau", "Ritueelgedreven merkverhalen"],
      positioning: "Een verfijnd formaat voor merken die het dagelijkse beautyritueel naar een hoger niveau tillen.",
      availability: "In ontwikkeling met partners",
      targetMarket: "Beauty-from-within en premium retail",
      docStatus: "Per markt voorbereid",
    },
    "sleep-relaxation": {
      name: "Slaap en ontspanning",
      desc: "Rustige, op de avond gerichte concepten, ontworpen rond eenvoud aan het einde van de dag.",
      possibilities: ["Positionering als avondritueel", "Discrete formaten voor op het nachtkastje", "Kalmerend sensorisch ontwerp"],
      positioning: "Gemaakt voor het rustige moment vóór het slapengaan.",
      availability: "In ontwikkeling met partners",
      targetMarket: "Avondwellness en apotheekretail",
      docStatus: "Per markt voorbereid",
    },
    "vitamins-functional": {
      name: "Vitaminen en functionele ingrediënten",
      desc: "Filmconcepten opgebouwd rond gevestigde functionele ingrediënten, gepresenteerd in een precies, modern formaat.",
      possibilities: ["Ingrediëntgedreven productfamilies", "Helder, eerlijk etiketontwerp", "Differentiatie via het formaat"],
      positioning: "Een eigentijds alternatief binnen gevestigde ingrediëntcategorieën.",
      availability: "In ontwikkeling met partners",
      targetMarket: "Nutraceutische en functionele retail",
      docStatus: "Per markt voorbereid",
    },
    "custom-private-label": {
      name: "Maatwerk- en private-labelconcepten",
      desc: "Een leeg canvas: ODF-concepten op maat, ontwikkeld onder het merk van de partner, van idee tot lancering.",
      possibilities: ["Volledig op maat gemaakte conceptontwikkeling", "Coördinatie van merk en verpakking", "Ondersteuning bij lancering en opschaling"],
      positioning: "Voor partners die een onderscheidend product willen dat onmiskenbaar van hen is.",
      availability: "Open voor briefings",
      targetMarket: "Merkeigenaren en retailers",
      docStatus: "Per project gedefinieerd",
    },
  },
};
